import React from 'react';
import TranslationContainer from '../../translation/translation_container';
import { PromotionText } from './promotion_text';

function Premium() {
    return (
        <TranslationContainer
            targetProperties={{
                flagText: { translationKey: 'catalog-promotions-promotion-text-flag-text-premium' },
                headline: { translationKey: 'catalog-promotions-promotion-text-headline-premium' },
                content: { translationKey: 'catalog-promotions-promotion-text-content-premium' },
            }}
        >
          <PromotionText
              type="premium"
              flagText="will-be-replaced"
              headline="will-be-replaced"
              content="will-be-replaced"
          />
        </TranslationContainer>
    );
}

export { Premium };